import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorPositionBuilder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="m12.1 3.81 7.153 3.747-7.153 3.747-7.153-3.747L12.1 3.809Zm.42-1.51a.897.897 0 0 0-.84 0L3.427 6.622c-.721.379-.721 1.489 0 1.867l8.255 4.324a.897.897 0 0 0 .839 0l8.254-4.324c.722-.378.722-1.488 0-1.867L12.52 2.3Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M20.968 13.481c.359-.184.512-.649.34-1.037-.17-.388-.6-.553-.96-.368l-8.13 4.175a.225.225 0 0 1-.216-.005l-8.46-4.867c-.352-.202-.788-.059-.975.32-.188.38-.055.851.297 1.053l8.46 4.867c.47.27 1.032.285 1.514.038l8.13-4.176Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M20.968 18.081c.359-.184.512-.649.34-1.037-.17-.388-.6-.553-.96-.368l-8.13 4.175a.225.225 0 0 1-.216-.005l-8.46-4.867c-.352-.202-.788-.059-.975.32-.188.38-.055.851.297 1.053l8.46 4.867c.47.27 1.032.285 1.514.037l8.13-4.175Z"
    />
  </svg>
);
export default SvgTwoColorPositionBuilder;
